import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';

class FaqPageService {
	getFaqData(language) {
		return axios
			.post(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/faq?lang=${language}`,
			)
			.then(res => res.data)
			.catch(logError);
	}
}

export default new FaqPageService();
